export default __webpack_public_path__ + "static/media/volk.ac5f59a6.png";